import useXcCompetition from "../useXcCompetition";
import dayjs from "dayjs";
import { useContext } from "react";
import { CarCompetitionData } from "../contextProvider";

const EndsBadge = ({ className = "", size = "hero" }: { className?: string; size?: "hero" | "specs" }) => {
  const carCompetition = useXcCompetition();
  const { competitionState, competitionEndDate } = useContext(CarCompetitionData);
  const endDate = competitionEndDate || carCompetition.EndDate || carCompetition.EndDateTime;
  if (!endDate) return null;

  const days = dayjs(endDate).diff(dayjs(), "days");
  if (!Number.isFinite(days)) return null;

  // Line breaks match Figma badge states (9054:10555)
  let lines: string[] = ["Finished"];
  switch (competitionState) {
    case "over14Weeks": {
      lines = ["Ends", `in ${days}`, days === 1 ? "day" : "days"];
      break;
    }
    case "nextWeek": {
      lines = ["Ends", "next", "week"];
      break;
    }
    case "thisWeek": {
      lines = ["Ends", "this", "week"];
      break;
    }
    case "last3Days": {
      lines = ["Ends", "in 3", "days"];
      break;
    }
    case "today":
    case "last2Days": {
      lines = ["Final", "hours"];
      break;
    }
  }

  const sizeClass = size === "specs" ? "size-20 lg:size-[100px]" : "size-20 lg:size-[153px]";

  return (
    <div
      className={`absolute z-10 flex ${sizeClass} flex-col items-center justify-center bg-black px-[15px] lg:px-4 py-6 lg:py-[19px] rounded-full ${className}`}>
      <div className="flex flex-col items-center justify-center text-white text-center font-jost text-base lg:text-lg font-bold leading-4 lg:leading-6 uppercase whitespace-nowrap">
        {lines.map((line, index) => (
          <span key={`${line}-${index}`} className="block leading-4 lg:leading-6">
            {line}
          </span>
        ))}
      </div>
    </div>
  );
};

export default EndsBadge;
